import { __extends } from "tslib";
import { Filter3DTaskBase } from './Filter3DTaskBase';
import { ContextGLProgramType } from '../../base/ContextGLProgramType';
var Filter3DCompositeTask = /** @class */ (function (_super) {
    __extends(Filter3DCompositeTask, _super);
    function Filter3DCompositeTask(blendMode, exposure) {
        if (exposure === void 0) { exposure = 1; }
        var _this = _super.call(this) || this;
        _this._data = new Float32Array([exposure, 0.5, 2.0, -1, 0.0, 0.0, 0.0, 0.0]);
        _this._blendMode = blendMode;
        return _this;
    }
    Object.defineProperty(Filter3DCompositeTask.prototype, "overlayTexture", {
        get: function () {
            return this._overlayTexture;
        },
        set: function (value) {
            this._overlayTexture = value;
            this._overlayWidth = this._overlayTexture.width;
            this._overlayHeight = this._overlayTexture.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Filter3DCompositeTask.prototype, "exposure", {
        get: function () {
            return this._data[0];
        },
        set: function (value) {
            this._data[0] = value;
        },
        enumerable: true,
        configurable: true
    });
    Filter3DCompositeTask.prototype.getFragmentCode = function () {
        var temp1 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp1, 1);
        var temp2 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp2, 1);
        var temp3 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp3, 1);
        var temp4 = this._registerCache.getFreeFragmentVectorTemp();
        this._registerCache.addFragmentTempUsages(temp4, 1);
        var inputTexture = this._registerCache.getFreeTextureReg();
        this._inputTextureIndex = inputTexture.index;
        var overlayTexture = this._registerCache.getFreeTextureReg();
        this._overlayTextureIndex = overlayTexture.index;
        var exposure = this._registerCache.getFreeFragmentConstant();
        this._exposureIndex = exposure.index * 4;
        var scaling = this._registerCache.getFreeFragmentConstant();
        this._scalingIndex = scaling.index * 4;
        var code;
        code = 'tex ' + temp1 + ', ' + this._uvVarying + ', ' + inputTexture + ' <2d,linear,clamp>\n' +
            'mul ' + temp2 + ', ' + this._uvVarying + ', ' + scaling + '.zw\n' +
            'add ' + temp2 + ', ' + temp2 + ', ' + scaling + '.xy\n' +
            'tex ' + temp2 + ', ' + temp2 + ', ' + overlayTexture + ' <2d,linear,clamp>\n' +
            'mul ' + temp2 + ', ' + temp2 + ', ' + exposure + '.xxx\n' +
            'add ' + temp2 + ', ' + temp2 + ', ' + exposure + '.xxx\n';
        switch (this._blendMode) {
            case 'multiply':
                code += 'mul oc, ' + temp1 + ', ' + temp2 + '\n';
                break;
            case 'add':
                code += 'add oc, ' + temp1 + ', ' + temp2 + '\n';
                break;
            case 'subtract':
                code += 'sub oc, ' + temp1 + ', ' + temp2 + '\n';
                break;
            case 'overlay':
                code += 'sge ' + temp3 + ', ' + temp1 + ', ' + exposure + '.yyy\n'; // t2 = (blend >= 0.5)? 1 : 0
                code += 'sub ' + temp1 + ', ' + temp3 + ', ' + temp1 + '\n'; // base = (1 : 0 - base)
                code += 'sub ' + temp2 + ', ' + temp2 + ', ' + temp3 + '\n'; // blend = (blend - 1 : 0)
                code += 'mul ' + temp2 + ', ' + temp2 + ', ' + temp1 + '\n'; // blend = blend * base
                code += 'sub ' + temp4 + ', ' + temp3 + ', ' + exposure + '.yyy\n'; // t3 = (blend >= 0.5)? 0.5 : -0.5
                code += 'div ' + temp2 + ', ' + temp2 + ', ' + temp4 + '\n'; // blend = blend / ( 0.5 : -0.5)
                code += 'add oc, ' + temp2 + ', ' + temp3 + '\n';
                break;
            case 'normal':
                // for debugging purposes
                code += 'mov oc, ' + temp1 + '\n';
                break;
            default:
                throw new Error('Unknown blend mode');
        }
        return code;
    };
    Filter3DCompositeTask.prototype.activate = function (stage, projection, depthTexture) {
        this._data[4] = -0.5 * (this._textureWidth - this._overlayWidth) / this._overlayWidth;
        this._data[5] = -0.5 * (this._textureHeight - this._overlayHeight) / this._overlayHeight;
        this._data[6] = this._textureWidth / this._overlayWidth;
        this._data[7] = this._textureHeight / this._overlayHeight;
        var context = stage.context;
        context.setProgramConstantsFromArray(ContextGLProgramType.FRAGMENT, this._data);
        this._overlayTexture
            .getAbstraction(stage)
            .activate(this._overlayTextureIndex);
    };
    Filter3DCompositeTask.prototype.deactivate = function (stage) {
        stage.context.setTextureAt(1, null);
    };
    return Filter3DCompositeTask;
}(Filter3DTaskBase));
export { Filter3DCompositeTask };
